export default "__VITE_ASSET__DH6_M$hU__"